import React from 'react';

const language = document.getElementById('lang').innerHTML;

function text(translationsMap) {
  let result = translationsMap[language];
  if (result == undefined) {
    return translationsMap['en'];
  } else {
    return translationsMap[language];
  }
}

export default [
  {
    id: 'ff_bz',
    data: {
      label: (
        <>
          {text({
            "ru": "Брокеры, для которых доступен готовый парсер:",
            "ua": "Брокери, для яких доступний готовий парсер:",
            "en": "Brokers with an available parser:",
            "es": "Corredores con un analizador sintáctico disponible:"
          })}
          <ul>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/ib_report/",
                               "ua": "https://es.robotaxmaker.com/uk/docs/ib_report/",
                               "en": "https://es.robotaxmaker.com/en/docs/ib_report/",
                               "es": "https://es.robotaxmaker.com/docs/ib_report/"})}
                   target='_blank'>Interactive Brokers</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/ff_cy_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/ff_cy_report",
                               "en": "https://es.robotaxmaker.com/en/docs/ff_cy_report",
                               "es": "https://es.robotaxmaker.com/docs/ff_cy_report"})}
                   target='_blank'>Freedom Finance</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/abylaigs_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/abylaigs_report",
                               "en": "https://es.robotaxmaker.com/en/docs/abylaigs_report",
                               "es": "https://es.robotaxmaker.com/docs/abylaigs_report"})}
                   target='_blank'>Abylai GS</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/revolut_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/revolut_report",
                               "en": "https://es.robotaxmaker.com/en/docs/revolut_report",
                               "es": "https://es.robotaxmaker.com/docs/revolut_report"})}
                   target='_blank'>Revolut</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/trade_station_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/trade_station_report",
                               "en": "https://es.robotaxmaker.com/en/docs/trade_station_report",
                               "es": "https://es.robotaxmaker.com/docs/trade_station_report"})}
                   target='_blank'>TradeStation</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/degiro_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/degiro_report",
                               "en": "https://es.robotaxmaker.com/en/docs/degiro_report",
                               "es": "https://es.robotaxmaker.com/docs/degiro_report"})}
                   target='_blank'>Degiro</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/charles_schwab_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/charles_schwab_report",
                               "en": "https://es.robotaxmaker.com/en/docs/charles_schwab_report",
                               "es": "https://es.robotaxmaker.com/docs/charles_schwab_report"})}
                   target='_blank'>Charles Schwab</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/citi_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/citi_report",
                               "en": "https://es.robotaxmaker.com/en/docs/citi_report",
                               "es": "https://es.robotaxmaker.com/docs/citi_report"})}
                   target='_blank'>Citibank, N.A.</a></li>
            <li><a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/exante_report",
                               "ua": "https://es.robotaxmaker.com/uk/docs/exante_report",
                               "en": "https://es.robotaxmaker.com/en/docs/exante_report",
                               "es": "https://es.robotaxmaker.com/docs/exante_report"})}
                   target='_blank'>Exante</a></li>
          </ul>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      width: 180,
      textAlign: 'left',
      border: '1px solid #0066CC',
    },
  },
  {
    id: 'excel',
    data: {
      label: (
        <>
          <a href={text({"ru": "https://es.robotaxmaker.com/ru/docs/robotaxmaker_format",
                         "ua": "https://es.robotaxmaker.com/uk/docs/robotaxmaker_format",
                         "en": "https://es.robotaxmaker.com/en/docs/robotaxmaker_format",
                         "es": "https://es.robotaxmaker.com/docs/robotaxmaker_format"})}
             target='_blank'>
            {text({
              "ru": "Заполнение в Excel",
              "ua": "Заповнення в Excel",
              "en": "Filling in Excel",
              "es": "Rellenar en Excel"
            })}
          </a>
        </>
      ),
    },
    position: { x: 200, y: 120 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      width: 120,
      border: '1px solid #ED6C02',
    },
  },
  {
    id: 'unknown',
    data: {
      label: (
        <>
          {text({
            "ru": <span>Другой<br/>брокер или банк</span>,
            "ua": <span>Інший<br/>брокер або банк</span>,
            "en": <span>Another<br/>broker or bank</span>,
            "es": <span>Otro<br/>corredor o banco</span>
          })}
        </>
      ),
    },
    position: { x: 200, y: 0 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      width: 120,
      border: '1px solid #000000',
    },
  },
  {
    id: 'finparser',
    data: {
      label: (
        <a href={text({
          "ru": "https://es.robotaxmaker.com/ru/tax-form/",
          "ua": "https://es.robotaxmaker.com/uk/tax-form/",
          "en": "https://es.robotaxmaker.com/en/tax-form/",
          "es": "https://es.robotaxmaker.com/tax-form/"
        })}
           target='_blank'>RoboTaxMaker
        </a>
      ),
    },
    position: { x: 185, y: 320 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #0066CC',
    },
  },
  {
    id: 'modelo720_prev',
    data: {
      label: (
        <div>
          <a href={text({
            "ru": "https://es.robotaxmaker.com/ru/modelo-720/",
            "ua": "https://es.robotaxmaker.com/uk/modelo-720/",
            "en": "https://es.robotaxmaker.com/en/modelo-720/",
            "es": "https://es.robotaxmaker.com/modelo-720/"
          })}
            target='_blank'>{text({
              "ru": 'Форма 720',
              "ua": 'Форма 720',
              "en": 'Form 720',
              "es": 'Modelo 720'
            })}
          </a><br />
          {text({
            "ru": '(за прошлый год)',
            "ua": '(за минулий рік)',
            "en": '(for the previous year)',
            "es": '(para el año anterior)'
          })}
        </div>
      ),
    },
    position: { x: 340, y: 0 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #000000',
    },
  },
  {
    id: 'modelo720_prev-a',
    data: { label: '' },
    position: { x: 415, y: 110 },
    type: 'emptyNode',
  },
  {
    id: 'modelo720_prev-b',
    data: { label: '' },
    position: { x: 330, y: 150 },
    type: 'emptyNode',
  },
  {
    id: 'modelo720_prev-c',
    data: { label: '' },
    position: { x: 330, y: 235 },
    type: 'emptyNode',
  },
  {
    id: 'modelo720_curr',
    data: {
      label: (
        <div>
          <a href={text({
            "ru": "https://es.robotaxmaker.com/ru/modelo-720/",
            "ua": "https://es.robotaxmaker.com/uk/modelo-720/",
            "en": "https://es.robotaxmaker.com/en/modelo-720/",
            "es": "https://es.robotaxmaker.com/modelo-720/"
          })}
            target='_blank'>{text({
              "ru": 'Форма 720',
              "ua": 'Форма 720',
              "en": 'Form 720',
              "es": 'Modelo 720'
            })}
          </a><br />
          {text({
            "ru": '(за отчетный год)',
            "ua": '(за звітний рік)',
            "en": '(for the reporting year)',
            "es": '(por el año contable)'
          })}
        </div>
      ),
    },
    position: { x: 340, y: 160 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #000000',
    },
  },
  {
    id: 'modelo720_curr-a',
    data: { label: '' },
    position: { x: 410, y: 265 },
    type: 'emptyNode',
  },
  {
    id: 'nalog.ru',
    data: {
      label: <a href={text({
        "ru": "https://sede.agenciatributaria.gob.es/Sede/en_gb/ayuda/consultas-informaticas/declaraciones-informativas-ayuda-tecnica/modelos-349-720/modelo-720-presentacion-mediante-fichero.html",
        "ua": "https://sede.agenciatributaria.gob.es/Sede/en_gb/ayuda/consultas-informaticas/declaraciones-informativas-ayuda-tecnica/modelos-349-720/modelo-720-presentacion-mediante-fichero.html",
        "en": "https://sede.agenciatributaria.gob.es/Sede/en_gb/ayuda/consultas-informaticas/declaraciones-informativas-ayuda-tecnica/modelos-349-720/modelo-720-presentacion-mediante-fichero.html",
        "es": "https://sede.agenciatributaria.gob.es/Sede/ayuda/consultas-informaticas/declaraciones-informativas-ayuda-tecnica/modelos-349-720/modelo-720-presentacion-mediante-fichero.html"
      })}
                target='_blank'>Agencia Tributaria Renta</a>,
    },
    position: { x: 185, y: 440 },
    type: 'allSidesNode',
    className: 'react-flow__node-default',
    style: {
      border: '1px solid #000000',
    },
  },
  // edges
  {
    id: 'ff_bz->finparser',
    source: 'ff_bz',
    target: 'finparser',
    data: {
      label: <>
        {text({
          "ru": <div>Отчет брокера<br />(CSV/Excel/PDF)</div>,
          "ua": <div>Звіт брокера<br />(CSV/Excel/PDF)</div>,
          "en": <div>Broker report<br />(CSV/Excel/PDF)</div>,
          "es": <div>Informe del corredor<br />(CSV/Excel/PDF)</div>
        })}
      </>,
      height: 30,
      width: 120
    },
    type: 'labelEdge',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  {
    id: 'modelo720_prev->modelo720_prev-a',
    source: 'modelo720_prev',
    target: 'modelo720_prev-a',
    data: {
      label: <>
        {text({
          "ru": <div>Данные по ценным<br /> бумагам (720)</div>,
          "ua": <div>Дані з цінних<br /> паперів (720)</div>,
          "en": <div>Securities data<br /> (720)</div>,
          "es": <div>Datos sobre valores<br /> mobiliarios (720)</div>
        })}
      </>,
      height: 30,
      width: 120
    },
    type: 'labelEdge',
    animated: true,
  },
  {
    id: 'modelo720_prev-a->modelo720_prev-b',
    source: 'modelo720_prev-a',
    target: 'modelo720_prev-b',
    animated: true,
  },
  {
    id: 'modelo720_prev-b->modelo720_prev-c',
    source: 'modelo720_prev-b',
    target: 'modelo720_prev-c',
    animated: true,
  },
  {
    id: 'modelo720_prev_c->robotaxmaker',
    source: 'modelo720_prev-c',
    target: 'finparser',
    animated: true,
  },
  {
    id: 'modelo720_curr->modelo720_curr-a',
    source: 'modelo720_curr',
    target: 'modelo720_curr-a',
    data: {
      label: <>
        {text({
          "ru": <div>Данные по иным<br /> активам (720)</div>,
          "ua": <div>Дані щодо інших<br /> активів (720)</div>,
          "en": <div>Data on other<br /> assets (720)</div>,
          "es": <div>Datos sobre otros<br /> activos (720)</div>
        })}
      </>,
      height: 30,
      width: 120
    },
    type: 'labelEdge',
    animated: true,
  },
  {
    id: 'modelo720_curr-a->robotaxmaker',
    source: 'modelo720_curr-a',
    target: 'finparser',
    animated: true,
  },
  {
    id: 'finparser->nalog.ru',
    source: 'finparser',
    target: 'nalog.ru',
    label: <>{text({
      "ru": 'Форма (720)',
      "ua": 'Форма (720)',
      "en": 'Form (720)',
      "es": 'Modelo (720)'
    })}</>,
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  // finparser - finparser-a - Пояснительная записка (PDF) - finparser-b -> nalog.ru
  {
    id: 'finparser-a',
    data: { label: '' },
    position: { x: 70, y: 350 },
    type: 'emptyNode',
  },
  {
    id: 'finparser-b',
    data: { label: '' },
    position: { x: 70, y: 450 },
    type: 'emptyNode',
  },
  {
    id: 'ff-b-nalog.ru',
    source: 'ff-b',
    target: 'nalog.ru',
    targetHandle: 'l',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  //
  {
    id: 'unknown->excel',
    source: 'unknown',
    target: 'excel',
    data: {
      label: (text({
        "ru": <div>Отчет в любом<br/>читаемом формате</div>,
        "ua": <div>Звіт у будь-якому<br/>читабельному форматі</div>,
        "en": <div>Report in any<br/>readable format</div>,
        "es": <div>Informe en cualquier<br/>formato legible</div>
      })),
      height: 30,
      width: 120
    },
    type: 'labelEdge',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  // excel - excel-a - Универсальный формат (Excel) - excel-b -> finparser
  {
    id: 'excel-a',
    data: { label: '',
    height: 40,
    width: 100},
    type: 'emptyNode',
    position: { x: 258, y: 195 },
  },
  {
    id: 'excel-b',
    data: { label: '' },
    position: { x: 258, y: 215 },
    type: 'emptyNode',
  },
  {
    id: 'excel->excel-a',
    source: 'excel',
    target: 'excel-a',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  {
    id: 'excel-a->excel-b',
    source: 'excel-a',
    target: 'excel-b',
    data: {
      label: <>
        {text({
          "ru": <div>Универсальный формат<br/>RoboTaxMaker (Excel)</div>,
          "ua": <div>Універсальний формат<br/>RoboTaxMaker (Excel)</div>,
          "en": <div>Universal format<br/>RoboTaxMaker (Excel)</div>,
          "es": <div>Formato universal<br/>RoboTaxMaker (Excel)</div>
        })}
      </>,
      height: 40,
      width: 120},
    type: 'labelEdge',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  },
  {
    id: 'excel-b-finparser',
    source: 'excel-b',
    target: 'finparser',
    style: { stroke: '#000000', strokeWidth: 1.5 },
    animated: true,
  }
];
